import { createContext } from "react";

export const MapRouterContext = createContext(null);
